<template>
    <b-form-group
            :id="name"
            :label="label"
            :label-for="name">
        <b-row>
            <b-col>
                <v-select multiple :value="value" @input="updateValue" :options="optionList"/>
            </b-col>
        </b-row>
    </b-form-group>
</template>

<script>
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'pb-design-shop-tile',
        props: ['placeholder', 'label', 'name', 'value'],
        data() {
            return {
                tileList: [],
                selectedItems: []
            };
        },
        created() {
            ContentAPI.fetchListByName("collection_moods").then((list) => {
                this.tileList = list;
            });
        },
        methods: {
            updateValue: function (value) {
                this.$emit('input', value.map((val, index) => {
                    return {
                        id: val.id,
                        label: val.label,
                        sort: index
                    }
                }));
            },
        },
        computed: {
            optionList() {
                return this.tileList.map(tile => {

                    return {
                        id: tile.id,
                        label: tile.identifier.value
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .pin-img-stage {
        position: relative;
        display: inline-block;

        .pin-container {
            position: absolute;
        }

        .pin {
            cursor: pointer;
            width: 25px;
            height: 25px;
            background-color: white;
            border-radius: 50%;
            box-shadow: 0 2px 30px 0 #4A4B4D;
            text-align: center;
            z-index: 999;
        }

        .pin-info {
            color: white;
            position: absolute;
            top: -20px;
            left: 20px;

            button {
                color: white;
            }
        }

        img {
            max-width: 100%;
            display: block;
            margin: auto;
            object-fit: cover;
        }
    }

    .article-select {
        position: absolute;
    }


</style>
